import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const UserActivateError = withLazyFallback(() => import('components/user/Activate/Error'));
const UserActivateInitiate = withLazyFallback(() => import('components/user/Activate/Initiate'));
const UserActivateNewPhone = withLazyFallback(() => import('components/user/Activate/NewPhone'));
const UserActivateStart = withLazyFallback(() => import('components/user/Activate/Start'));
const UserActivateSuccess = withLazyFallback(() => import('components/user/Activate/Success'));
const UserActivateVerifyPhone = withLazyFallback(
  () => import('components/user/Activate/VerifyPhone')
);
const UserActivateWrapper = withLazyFallback(() => import('components/user/Activate/Wrapper'));

const USER_ACTIVATION = [
  {
    path: 'activate',
    element: <UserActivateWrapper />,
    children: [
      { path: 'initiate/:token', element: <UserActivateInitiate /> },
      { path: 'start', element: <UserActivateStart /> },
      {
        path: 'error',
        element: <UserActivateError />,
        children: [
          { path: ':kind', element: <UserActivateError /> },
          { path: '*', element: <UserActivateError /> }
        ]
      },
      { path: 'confirm-code', element: <UserActivateVerifyPhone /> },
      { path: 'new-phone', element: <UserActivateNewPhone /> },
      { path: 'success', element: <UserActivateSuccess /> },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default USER_ACTIVATION;
